module.exports = __webpack_public_path__ + "static/redlinebackground-min-8df707ae4fcc96e3a1b8c98e301777ec.png";